import { useQuery, type UseQueryResult } from '@tanstack/react-query'

import { getFundUpdateCategories } from 'src/app/home/adapters'
import { fundUpdatesKeys } from 'src/app/home/queries/keys'

const ONE_HOUR_MS = 60 * 60 * 1000

export interface IUseFundUpdateCategoriesQueryParams {
  enabled: boolean
}

export const useFundUpdateCategoriesQuery = (
  params: IUseFundUpdateCategoriesQueryParams,
): UseQueryResult<string[], Error> => {
  return useQuery({
    queryKey: fundUpdatesKeys.categories(),
    meta: { silent: true },
    staleTime: ONE_HOUR_MS,
    queryFn: async (): Promise<string[]> => {
      const response = await getFundUpdateCategories()
      return response.categories
    },
    enabled: params.enabled,
  })
}
